import React from "react";
import { Link, useNavigate } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import { ArrowLeft, Clock } from "lucide-react";

/**
 * Fase 13.2.5 · Placeholder unificado para páginas legales/empresa/redes
 * que todavía no existen. Mismo look que el resto del sitio.
 */
export default function Placeholder() {
  const nav = useNavigate();
  return (
    <PublicLayout>
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
        <div className="mx-auto w-16 h-16 rounded-full bg-primary/10 border border-primary/30 flex items-center justify-center">
          <Clock className="w-7 h-7 text-primary" />
        </div>
        <p className="mt-6 text-xs uppercase tracking-widest text-[#F26A21] font-semibold">
          Próximamente
        </p>
        <h1 className="mt-2 text-4xl font-bold text-[#0B0B0B] font-display">
          Esta sección estará disponible pronto
        </h1>
        <p className="mt-4 text-gray-600 max-w-md mx-auto">
          Estamos trabajando en el contenido de esta página. Mientras tanto,
          puedes explorar el catálogo o hablar con nuestro equipo.
        </p>
        <div className="mt-8 flex justify-center gap-3 flex-wrap">
          <button
            onClick={() => nav(-1)}
            data-testid="placeholder-back-btn"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-gray-300 text-[#0B0B0B] hover:bg-black/5 text-sm font-semibold"
          >
            <ArrowLeft className="w-4 h-4" /> Volver
          </button>
          <Link
            to="/catalogo"
            data-testid="placeholder-catalog-btn"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-[#F26A21] hover:bg-[#D9541A] text-[#0B0B0B] text-sm font-semibold"
          >
            Explorar catálogo
          </Link>
        </div>
      </section>
    </PublicLayout>
  );
}
